import { Modal } from 'almanac-ui/Modal'
import { ConfirmModal } from 'hooks/useConfirmModal'

export const AiConfirmModal = ({ onCancel, onConfirm, onPressOutside }: ConfirmModal) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header
      title="Confirmation"
      subHeader="Are you sure you want to leave your AI image generation work? You will lose all unsaved changes."
    />
    <Modal.Content></Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Modal.FooterButton onPress={onCancel} size="lg" variant="tertiary">
          Cancel
        </Modal.FooterButton>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Modal.FooterButton onPress={onConfirm} size="lg" variant="primary">
          Confirm
        </Modal.FooterButton>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
